import { onDomReady } from '@js/src/helpers';
import { createApp } from 'vue';
import FiltersFull from '@js/src/components/FiltersFull.vue';

onDomReady(function () {
    createApp(FiltersFull)
        .mount('#filters-full');
});
